import React from 'react';
import { convertAmount, getAmountWithCurrency, useTranslation } from '@pascal/pascal-core';
import starImg from '../../../assets/images/star.png';
import { TranslationKeys } from '../../../enums/translationKeys';

const WinPopUp = ({ win }) => {
  const t = useTranslation();

  return (
    <div className='fs-win-popup'>
      <div className='fs-win-block'>
        <div className='fs-win-ring'>
          <span className='fs-star' data-index='1'>
            <img src={starImg} alt='starImg' />
          </span>
          <span className='fs-star' data-index='2'>
            <img src={starImg} alt='starImg' />
          </span>
          <span className='fs-star' data-index='3'>
            <img src={starImg} alt='starImg' />
          </span>
          <span className='fs-star' data-index='4'>
            <img src={starImg} alt='starImg' />
          </span>
          <span className='fs-win-label'>{t(TranslationKeys.YOUR_WIN)}</span>
          <span className='fs-win-num'>
            {getAmountWithCurrency({ amount: convertAmount(win?.winAmount) })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default WinPopUp;
